import { useContext } from "react"
import { PeriodoEntregaFornecedorContext } from "./PeriodoEntregaFornecedorContext"

export function usePeriodoEntregaFornecedorContext() {
    return useContext(PeriodoEntregaFornecedorContext)
}
